import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { CommonTranslateModule } from "@shared/utils/common-translate.module";
import { ResendVerifyComponent } from "./resend-verify.component";

@NgModule({
  declarations: [ResendVerifyComponent],
  providers: [],
  imports: [CommonModule, CommonTranslateModule, FormsModule, ReactiveFormsModule, RouterModule],
  exports: [ResendVerifyComponent],
})
export class ResendVerifyModule {}
